import {
    escapeHTML,
    monthNames,
    hideMainMenuContent,
    makeGameRequest,
    getChampionshipsInfo,
    getItemListDiv, getRosterInfo, getBrandsInfo, getCompanyInfo, toCamel, getItemColumnDiv, makeGetRequest
} from "./ui-helpers.js";
import {createGameFromScenarioData} from "../modules/games.js";
import {goToGameFromMainMenu} from "./games.js";
import {globals, globalUser} from "../modules/globals.js";
import {playSoundEffect} from "./sounds.js"
import {showCustomStartingCompanyChampionshipGraphic} from "./graphics.js";
import {generateCustomStartingCompany} from "../modules/generate.js";
import {gameLimits} from "../modules/helpers.js";
import {loadUser} from "../modules/user.js";

$(document).ready(function () {
    // Get random scenario
    $('.scenario-random-button').on('click', function () {
        if (globals.requestRunning) {
            return false;
        }

        $('.scenario-menu .button').removeClass('selected');
        $(this).addClass('selected');

        // Reset search and category containers, menu and sort
        $('.scenario-sort').val('rating');
        $('.scenario-categories').hide();
        $('.scenario-categories-button').removeClass('selected');
        $('.scenario-search-container').hide();
        $('.scenario-search-button').removeClass('selected');

        getScenarios('random');
    });

    // Select scenario filter
    $('.scenario-filter').on('click', function () {
        if (globals.requestRunning) {
            return false;
        }

        let $this = $(this);
        $('.scenario-menu .button').removeClass('selected');

        // Keep category button selected if clicking on sub category
        if ($this.parent().hasClass('scenario-categories')) {
            $('.scenario-categories-button').addClass('selected')
        }
        // Remove categories if not clicking on sub category
        else {
            $('.scenario-categories').hide();
        }
        // Remove search
        $('.scenario-search-container').hide();

        // Select default sort
        $('.scenario-sort').val($this.attr('data-default-sort'));

        $(this).addClass('selected');

        // Get filtered scenarios
        getScenarios($this.attr('data-value'));
    });

    // Show scenario categories
    $('.scenario-categories-button').on('click', function () {
        playSoundEffect('success');
        let $this = $(this);
        if ($this.hasClass('selected')) {
            $this.removeClass('selected');
            $('.scenario-categories').hide();
        }
        else {
            $('.scenario-menu .button').removeClass('selected');
            $this.addClass('selected');
            $('.scenario-categories').show();
            $('.scenario-search-container').hide();
        }
    });

    // Show scenario search
    $('.scenario-search-button').on('click', function () {
        playSoundEffect('success');
        let $this = $(this);
        if ($this.hasClass('selected')) {
            $this.removeClass('selected');
            $('.scenario-search-container').hide();
        }
        else {
            // Reset menus, except 'All', as it is used to see if all scenarios loaded or not
            $('.scenario-menu .button:not([data-value="all"])').removeClass('selected');
            $this.addClass('selected');
            $('.scenario-search-container').show();
            $('.scenario-categories').hide();
            $('.scenario-search-input').focus();
        }
    });

    // Select 'any' radio if starting year entered
    $('.search-starting-year').on('input', function () {
        if ($(this).val()) {
            $('input[type="radio"][name="radio-scenario-search-period"]')
                .filter('[value="any"]').prop('checked', true);
        }
    });

    // Show scenario search options
    $('.scenario-search-options-button').on('click', function () {
        playSoundEffect('success');
        if ($('.scenario-search-options').is(":visible")) {
            $('.scenario-search-options').hide();
            $(this).html(
                '<span class="font-0p875em">More options</span> <i class="fa fa-angle-down"></i>'
            );
        }
        else {
            $('.scenario-search-options').show();
            $(this).html(
                '<span class="font-0p875em">Hide options</span> <i class="fa fa-angle-up"></i>'
            );
        }
    });

    // Sort scenarios
    $('.scenario-sort').on('change', function () {
        playSoundEffect('success');
        let value = $(this).val();
        let scenariosContainerName = 'user-scenarios';
        if ($('.scenario-menu').find('.scenario-search-button').hasClass('selected')) {
            scenariosContainerName = 'scenarios-search-results'
        }

        let userScenariosElement = document.getElementById(scenariosContainerName);

        // Sort elements by selected option
        let sortedElements = $(userScenariosElement).find('.scenario');
        if (value === 'rating') {
            sortedElements.sort(function (a, b) {
                let ratingA = ($(a).attr('data-rating')) ? parseFloat($(a).attr('data-rating')) : 0;
                let ratingB = ($(b).attr('data-rating')) ? parseFloat($(b).attr('data-rating')) : 0;
                return (ratingB - ratingA);
            });
        }
        else if (value === 'plays') {
            sortedElements.sort(function (a, b) {
                return (parseFloat($(b).attr('data-plays')) - parseFloat($(a).attr('data-plays')));
            });
        }
        else if (value === 'updated') {
            sortedElements.sort(function (a, b) {
                let dateA = ($(a).attr('data-updated')) ? new Date($(a).attr('data-updated')) : new Date(0);
                let dateB = ($(b).attr('data-updated')) ? new Date($(b).attr('data-updated')) : new Date(0);
                return (dateB - dateA);
            });
        }

        sortedElements.toArray().forEach(function (e) {
            userScenariosElement.appendChild(e);
        });
    });

    // Search scenarios
    $('.button-scenario-search').on('click', function () {
        runScenariosSearch();
    });
    $(".scenario-search-input, .search-company-name, .search-starting-year").keypress(function (e) {
        // Trigger search on enter key press
        if (e.which === 13 && $('.scenario-search-button').hasClass('selected')) {
            $(".button-scenario-search").click();
        }
    });

    // Show/hide sandbox mode options
    $("#container").on('change', '.game-mode-option input[type="radio"]', function () {
        if ($(this).val() === 'sandbox') {
            $(this).closest('.game-mode-option').find('.sandbox-mode-options').show()
        }
        else {
            $(this).closest('.game-mode-option').find('.sandbox-mode-options').hide()
        }
    });
    $("#container").on('change', '.game-mode-option-new-game-options input[type="radio"]', function () {
        if ($(this).val() === 'sandbox') {
            $(this).closest('.game-mode-option-new-game-options').find('.sandbox-mode-options-new-game-options').show()
        }
        else {
            $(this).closest('.game-mode-option-new-game-options').find('.sandbox-mode-options-new-game-options').hide()
        }
    });

    // Change competitors upon starting company change
    $("#new-game-menu").on('change', '#select-starting-company', function () {
        let defaultCompetition = $(this).parent().siblings('.competitors').find('#default-competition');
        let customStartingCompany = $(this).parent().siblings('.custom-starting-company-option').find('input[type="radio"]:checked').val();
        let $this = $(this);

        if (defaultCompetition.length > 0 && customStartingCompany !== 'yes') {

            // Update select competitors if present
            let selectCompetitorsDiv = $this.closest('.starting-company').siblings('.select-competitors');
            if (selectCompetitorsDiv.length > 0) {

                // Get all companies except selected starting company
                let allCompetitors = []
                $this.find('option').each(function (i, option) {
                    if ($(option).prop('selected') === false) {
                        allCompetitors.push($(option).text())
                    }
                });

                // Add checkboxes for all competitors
                let competitorCheckboxes = '';
                allCompetitors.forEach(function (competitor, i) {
                    let checked = (i >= gameLimits.maxCompetitors) ? '' : ' checked="checked"';
                    competitorCheckboxes += '<label class="control control--checkbox display-block">' +
                        '<span class="select-competitor-name">' + escapeHTML(competitor) + '</span>' +
                        '<input type="checkbox" class="select-competitor-checkbox" value="' + competitor.replace(/"/g, "&quot;") + '"' + checked + '>' +
                        '    <div class="control__indicator"></div>' +
                        '</label>';
                });

                selectCompetitorsDiv.find('.select-competitors-checkboxes').html(competitorCheckboxes);
            }
        }
    });

    // Show/hide select select competitors checkboxes
    $("#new-game-menu").on('click', '.none-competitors-radio, .generate-competitors-radio', function () {
        let selectCompetitorsDiv = $(this).closest('.competitors').siblings('.select-competitors');
        if (selectCompetitorsDiv.length > 0) {
            selectCompetitorsDiv.hide()
        }
    });
    $("#new-game-menu").on('change', '.standard-competitors-radio', function () {
        let selectCompetitorsDiv = $(this).closest('.competitors').siblings('.select-competitors');
        if (selectCompetitorsDiv.length > 0) {
            selectCompetitorsDiv.show()
        }
    });

    // Limit competitor selections
    $("#new-game-menu").on('click', '.select-competitor-checkbox', function () {
        let selectedCheckboxes = $(this).closest('.select-competitors-checkboxes').find('.select-competitor-checkbox:checked');
        if (selectedCheckboxes.length > gameLimits.maxCompetitors) {
            notie.alert({type: 4, text: `You cannot select more than ${gameLimits.maxCompetitors} competitors`, stay: true});
            $(this).prop('checked', false);
        }
    });

    // Singleplayer / local multiplayer options
    $("#container").on('change', '.player-mode-option input[type="radio"]', function () {
        if ($(this).val() === 'singleplayer') {
            $(this).closest('.player-mode-option').siblings('.starting-company, .competitors, .select-competitors, .custom-starting-company-option').show();
            if (['generate', 'none'].includes($(this).closest('.player-mode-option').siblings('.competitors').find('input[type="radio"]:checked').val())) {
                $(this).closest('.player-mode-option').siblings('.select-competitors').hide();
            }
            $(this).closest('.player-mode-option').siblings('.companies-list').hide()
        }
        else {
            $(this).closest('.player-mode-option').siblings('.starting-company, .competitors, .select-competitors, .custom-starting-company-option').hide()
            $(this).closest('.player-mode-option').siblings('.companies-list').show();
        }
    });

    // Show player name input if 'user' radio option selected
    $("#container").on('change', '.companies-list input[type="radio"]', function () {

        // Limit companies
        let selectedCompanies = $(this).closest('.companies-list').find('input[type="radio"][value!="none"]:checked');
        if (selectedCompanies.length > gameLimits.maxCompetitors + 1) {
            notie.alert({type: 4, text: `You cannot select more than ${gameLimits.maxCompetitors + 1} companies`, stay: true});
            $(this).parent().parent().find('input[value="none"]').prop('checked', true);
            return false;
        }

        if ($(this).val() === 'user') {
            $(this).parent().siblings('.player-name-input').show()
        }
        else {
            $(this).parent().siblings('.player-name-input').hide()
        }
    });

    // Show/hide draft options
    $("#container").on('change', '.main-rosters-option input[type="radio"]', function () {
        if ($(this).val() === 'draft') {
            $(this).closest('.main-rosters-option').find('.draft-options').show()
        }
        else {
            $(this).closest('.main-rosters-option').find('.draft-options').hide()
        }
    });
    $("#container").on('change', '.main-rosters-option-new-game-options input[type="radio"]', function () {
        if ($(this).val() === 'draft') {
            $(this).closest('.main-rosters-option-new-game-options').find('.draft-options-new-game-options').show()
        }
        else {
            $(this).closest('.main-rosters-option-new-game-options').find('.draft-options-new-game-options').hide()
        }
    });

    // Show scenario information
    $("#container").on('click', '.show-scenario-information', function () {
        if (globals.requestRunning) {
            return false;
        }
        playSoundEffect('success');
        let parent = $(this).parent('.scenario');

        // Remove other info divs
        $('.scenario-information-content').hide();

        // Show new div
        if (parent.find('.scenario-information-content').length < 1) {
            parent.append('<div class="scenario-information-content line-height-24px dark-grey"></div>');
        }
        let uid = parent.attr('data-uid');
        let scenarioEdit = parent.find('.scenario-edit.selected');
        if (scenarioEdit.length > 0) {
            uid = scenarioEdit.attr('data-uid')
        }
        let version = parent.find('.versions').find('#select-version').val();
        let el = parent.find('.scenario-information-content');
        $(el).html('').hide();

        makeGetRequest('/_get_scenario_information', {uid: uid, version: version},
            (data) => showScenarioInformation(toCamel(data), el)  // uses python data format, so convert to camel case
        );
    });

    // Show scenario version info
    $("#new-game-menu").on('change', '#select-version', function () {
        let version = $(this).val();
        let competition = $(this).find('option:selected').attr('data-competition');
        let startingCompany = $(this).find('option:selected').attr('data-company-name');
        let customStartingCompany = $(this).parent().siblings('.custom-starting-company-option').find('input[type="radio"]:checked').val();

        // Show version's comments
        let versionComments = $(this).siblings('.version-comments');
        versionComments.find($('div[data-version="' + version + '"]')).show();
        versionComments.find($('div[data-version!="' + version + '"]')).hide();

        // Show version's competition
        let defaultCompetition = $(this).parent().siblings('.competitors').find('#default-competition');
        let startingCompanyElement = $(this).parent().siblings('.starting-company').find('#select-starting-company');
        if (competition) {
            // Check standard competition
            defaultCompetition.siblings('input').prop('checked', true);
            defaultCompetition.parent().removeClass('display-none');

            // Change starting company options
            let competitors = JSON.parse(competition);
            let options = '';
            options += '<option selected data-default="true" value="">' + escapeHTML(startingCompany) + '</option>';
            competitors.forEach(function (competitor, i) {
                options += '<option value="' + competitor.replace(/"/g, "&quot;") + '">' + escapeHTML(competitor) + '</option>';
            });
            startingCompanyElement.html(options);
        }
        else {
            // Check generate option
            defaultCompetition.parent().next().find('input').prop('checked', true);
            defaultCompetition.parent().addClass('display-none');

            // Change starting company options
            let options = '';
            options += '<option selected data-default="true" value="">' + escapeHTML(startingCompany) + '</option>';
            startingCompanyElement.html(options);
        }

        // Unselect edits
        $('.scenario-edit.selected').removeClass('selected');

        // Update select competitors if present
        let selectCompetitorsDiv = $(this).parent().siblings('.select-competitors');
        let playerModeOption = $(this).parent().siblings('.player-mode-option').find('input[type="radio"]:checked').val();
        if (selectCompetitorsDiv.length > 0) {

            // Get all companies except selected starting company
            let allCompetitors = []
            startingCompanyElement.find('option').each(function (i, option) {
                if (customStartingCompany === 'yes' || ($(option).prop('selected') === false)) {
                    allCompetitors.push($(option).text())
                }
            });

            // Add checkboxes for all competitors
            let competitorCheckboxes = '';
            allCompetitors.forEach(function (competitor, i) {
                let checked = (i >= gameLimits.maxCompetitors) ? '' : ' checked="checked"';
                competitorCheckboxes += '<label class="control control--checkbox display-block">' +
                    '<span class="select-competitor-name">' + escapeHTML(competitor) + '</span>' +
                    '<input type="checkbox" class="select-competitor-checkbox" value="' + competitor.replace(/"/g, "&quot;") + '"' + checked + '>' +
                    '    <div class="control__indicator"></div>' +
                    '</label>';
            });

            selectCompetitorsDiv.find('.select-competitors-checkboxes').html(competitorCheckboxes);

            // Show if competitors present in this version and local multiplayer not selected
            if (allCompetitors.length > 0 && playerModeOption !== 'local-multiplayer') {
                selectCompetitorsDiv.show()
            }
            else {
                selectCompetitorsDiv.hide()
            }
        }

        // Update select companies if present
        let selectCompaniesDiv = $(this).closest('.scenario').find('.companies-list');
        if (selectCompaniesDiv.length > 0) {

            // Get all companies
            let allCompanies = []
            startingCompanyElement.find('option').each(function (i, option) {
                allCompanies.push($(option).text())
            });

            // Add radio selects for all competitors
            let companiesListHtml = '';
            let scenarioUid = $(this).closest('.scenario, .scenario-edit').attr('data-uid');
            allCompanies.forEach(function (competitor, i) {
                companiesListHtml += getCompaniesListItemHtml(competitor, i, scenarioUid)
            });

            selectCompaniesDiv.find('.company-list-item').remove();
            selectCompaniesDiv.append(companiesListHtml);
        }
    });

    // Show/hide scenario edits
    $("#new-game-menu").on('click', '.scenario-edits-show-button', function () {
        let editsContainer = $(this).closest('.scenario').find('.scenario-edits-container');
        if ($(this).text() === 'Show Edits') {
            if (editsContainer.is(':empty')) {
                let scenarioUid = $(this).closest('.scenario').attr('data-uid');
                getScenarioEdits(scenarioUid, editsContainer, 'best');
            }
            else {
                editsContainer.show();
                editsContainer.find('.scroll-container').scrollTop(0);
            }
            $(this).text('Hide Edits');
        }
        else {
            editsContainer.hide();
            $(this).text('Show Edits');
        }
    });

    // Show scenario edit info
    $("#new-game-menu").on('click', '.show-scenario-edit-info', function (e) {
        e.stopPropagation();
        let infoElement = $(this).siblings('.scenario-edit-info');
        if (infoElement.is(":visible")) {
            infoElement.hide()
        }
        else {
            infoElement.show()
        }
    });

    // Sort scenario edits
    $("#new-game-menu").on('click', '.sort-scenario-edits-button', function (e) {
        let editsContainer = $(this).closest('.scenario').find('.scenario-edits-container');
        if (!$(this).hasClass('selected')) {
            editsContainer.find('.sort-scenario-edits-button').removeClass('selected');
            $(this).addClass('selected');
        }

        let scenarioUid = $(this).closest('.scenario').attr('data-uid');
        getScenarioEdits(scenarioUid, editsContainer, $(this).attr('data-value'));
    });

    // Scenario edit page buttons
    $("#new-game-menu").on('click', '.scenario-edits-next-page-button, .scenario-edits-previous-page-button', function () {
        let page = $(this).data('page');
        let editsContainer = $(this).closest('.scenario').find('.scenario-edits-container');
        let sort = editsContainer.find('.sort-scenario-edits-button.selected').attr('data-value');
        let scenarioUid = $(this).closest('.scenario').attr('data-uid');
        getScenarioEdits(scenarioUid, editsContainer, sort, page);
    });

    // Show scenario edit info
    $("#new-game-menu").on('click', '.scenario-edit', function () {

        // Select, unselect
        let competition;
        let startingCompany;
        if ($(this).hasClass('selected')) {
            $(this).removeClass('selected');
            // Revert to competition and starting company of selected version
            competition = $(this).closest('.scenario').find('#select-version').find('option:selected').attr('data-competition');
            startingCompany = $(this).closest('.scenario').find('#select-version').find('option:selected').attr('data-company-name');
        }
        else {
            $('.scenario-edit').removeClass('selected');
            $(this).addClass('selected');
            competition = $(this).attr('data-competition');
            startingCompany = $(this).attr('data-company-name');
        }

        // Show edit's competition
        let defaultCompetition = $(this).closest('.scenario').find('.competitors').find('#default-competition');
        let startingCompanyElement = $(this).closest('.scenario').find('.starting-company').find('#select-starting-company');
        let customStartingCompany = $(this).closest('.scenario').find('.custom-starting-company-option').find('input[type="radio"]:checked').val();

        if (competition) {
            // Check standard competition
            defaultCompetition.siblings('input').prop('checked', true);
            defaultCompetition.parent().removeClass('display-none');

            // Change starting company options
            let competitors = JSON.parse(competition);
            let options = '';
            options += '<option selected data-default="true" value="">' + escapeHTML(startingCompany) + '</option>';
            competitors.forEach(function (competitor, i) {
                options += '<option value="' + competitor.replace(/"/g, "&quot;") + '">' + escapeHTML(competitor) + '</option>';
            });
            startingCompanyElement.html(options);

        }
        else {
            // Check generate option
            defaultCompetition.parent().next().find('input').prop('checked', true);
            defaultCompetition.parent().addClass('display-none');

            // Change starting company options
            let options = '';
            options += '<option selected data-default="true" value="">' + escapeHTML(startingCompany) + '</option>';
            startingCompanyElement.html(options);
        }

        // Update select competitors if present
        let selectCompetitorsDiv = $(this).closest('.scenario').find('.select-competitors');
        let playerModeOption = $(this).closest('.scenario').find('.player-mode-option input[type="radio"]:checked').val();
        if (selectCompetitorsDiv.length > 0) {

            // Get all companies except selected starting company
            let allCompetitors = []
            startingCompanyElement.find('option').each(function (i, option) {
                if (customStartingCompany === 'yes' || $(option).prop('selected') === false) {
                    allCompetitors.push($(option).text())
                }
            });

            // Add checkboxes for all competitors
            let competitorCheckboxes = '';
            allCompetitors.forEach(function (competitor, i) {
                let checked = (i >= gameLimits.maxCompetitors) ? '' : ' checked="checked"';
                competitorCheckboxes += '<label class="control control--checkbox display-block">' +
                    '<span class="select-competitor-name">' + escapeHTML(competitor) + '</span>' +
                    '<input type="checkbox" class="select-competitor-checkbox" value="' + competitor.replace(/"/g, "&quot;") + '"' + checked + '>' +
                    '    <div class="control__indicator"></div>' +
                    '</label>';
            });

            selectCompetitorsDiv.find('.select-competitors-checkboxes').html(competitorCheckboxes);

            // Show if competitors present in this edit and local multiplayer not selected
            if (allCompetitors.length > 0 && playerModeOption !== 'local-multiplayer') {
                selectCompetitorsDiv.show()
            }
            else {
                selectCompetitorsDiv.hide()
            }
        }

        // Update select companies if present
        let selectCompaniesDiv = $(this).closest('.scenario').find('.companies-list');
        if (selectCompaniesDiv.length > 0) {

            // Get all companies
            let allCompanies = []
            startingCompanyElement.find('option').each(function (i, option) {
                allCompanies.push($(option).text())
            });

            // Add checkboxes for all competitors
            let companiesListHtml = '';
            let scenarioUid = $(this).closest('.scenario, .scenario-edit').attr('data-uid');
            allCompanies.forEach(function (competitor, i) {
                companiesListHtml += getCompaniesListItemHtml(competitor, i, scenarioUid)
            });

            selectCompaniesDiv.find('.company-list-item').remove();
            selectCompaniesDiv.append(companiesListHtml);
        }
    });

    // Rate scenario buttons
    $("#new-game-menu").on('click', '.rate-up, .rate-down', function (e) {
        e.stopPropagation();
        if (globals.requestRunning) {
            return false;
        }

        let el = $(this);
        let uid = $(this).closest('.scenario, .scenario-edit').attr('data-uid');
        let rating = $(this).hasClass('rate-up') ? 'up' : 'down';
        let classToCheck = $(this).hasClass('rate-up') ? 'positive' : 'negative';
        let classToRemove = classToCheck === 'positive' ? 'negative' : 'positive';
        let elementToRemoveClassFrom = classToCheck === 'positive' ? $(el).next() : $(el).prev();

        makeGetRequest('/_rate_scenario', {uid: uid, rating: rating}, (data) => {
            if (!data['error']) {
                playSoundEffect('success');
                if ($(el).hasClass(classToCheck)) {
                    $(el).removeClass(classToCheck);
                }
                else {
                    $(el).addClass(classToCheck);
                }
                elementToRemoveClassFrom.removeClass(classToRemove);
            }
            else if (data['error'] === 'not-signed-in') {
                playSoundEffect('error');
                notie.alert({
                    type: 4, text: 'You need to be logged in to rate scenarios',
                    stay: true
                });
            }
        });
    });

    // Delete scenario button
    $("#container").on('click', '.delete-scenario', function () {
        if (globals.requestRunning) {
            return false;
        }

        let parent = $(this).parent('.scenario');
        let uid = parent.attr('data-uid');

        notie.confirm({
            text: 'Are you sure you want to delete all versions of this scenario?',
            submitText: 'Yes',
            cancelText: 'No',
            submitCallback: function () {
                if (globals.requestRunning) {
                    return false;
                }
                makeGetRequest('/_delete_scenario', {uid: uid}, (data) => {
                    if (data) {
                        playSoundEffect('success');
                        notie.alert({type: 4, text: "Scenario deleted", stay: true});
                        parent.hide();
                    }
                });
            }
        });
    });

    // Delete scenario edit button
    $("#new-game-menu").on('click', '.delete-scenario-edit', function (e) {
        e.stopPropagation();
        if (globals.requestRunning) {
            return false;
        }

        let parent = $(this).parent('.scenario-edit');
        let uid = parent.attr('data-uid');

        notie.confirm({
            text: 'Are you sure you want to delete this scenario edit?',
            submitText: 'Yes',
            cancelText: 'No',
            submitCallback: function () {
                if (globals.requestRunning) {
                    return false;
                }
                makeGetRequest('/_delete_scenario_edit', {uid: uid}, (data) => {
                    if (!data['error']) {
                        playSoundEffect('success');
                        notie.alert({type: 4, text: "Scenario edit deleted", stay: true});
                        parent.hide();
                    }
                    else {
                        playSoundEffect('error');
                        if (data['error'] === 'incorrect-user') {
                            notie.alert({type: 3, text: 'You cannot delete this scenario edit because it doesn\'t belong to you'})
                        }
                        else if (data['error'] === 'not-logged-in') {
                            notie.alert({type: 3, text: 'You need to be logged in to delete scenario edits'})
                        }
                        else if (data['error'] === 'already-deleted') {
                            notie.alert({type: 3, text: 'This scenario edit has already been deleted'})
                        }
                    }
                });
            }
        });
    });

    /*
    CUSTOM STARTING COMPANY
     */

    // Add/remove starting company to competitors upon selecting custom starting company
    $("#new-game-menu").on('change', '.custom-starting-company-option input[type="radio"]', function () {
        let value = $(this).val();
        let parent = $(this).closest('.custom-starting-company-option');

        // Add starting company
        if (value === 'yes') {
            let startingCompanyValue = parent.siblings('.starting-company').find('#select-starting-company option:selected').text();

            // Update select competitors if present
            let selectCompetitorsDiv = parent.siblings('.select-competitors');
            if (selectCompetitorsDiv.length > 0) {
                let checked = (selectCompetitorsDiv.find('.select-competitor-checkbox:checked').length >=
                    gameLimits.maxCompetitors) ? '' : ' checked="checked"';
                let startingCompanyCheckbox = '<label class="control control--checkbox display-block">' +
                    '<span class="select-competitor-name">' + escapeHTML(startingCompanyValue) + '</span>' +
                    '<input type="checkbox" class="select-competitor-checkbox" value="' +
                        startingCompanyValue.replace(/"/g, "&quot;") + '"' + checked + '">' +
                    '    <div class="control__indicator"></div>' +
                    '</label>';
                selectCompetitorsDiv.find('.select-competitors-checkboxes').prepend(startingCompanyCheckbox);
            }
        }
        // Remove starting company
        else {
            let startingCompanyValue = parent.siblings('.starting-company').find('#select-starting-company option:selected').text();
            let startingCompanyOption = parent.siblings('.select-competitors').find('.select-competitors-checkboxes')
                .find('input[value="' + startingCompanyValue.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,'\\$1') + '"]');
            if (startingCompanyOption.length > 0) {
                startingCompanyOption.parent().remove()
            }
        }
    });

    // Add custom starting company championship input
    $('.custom-starting-company-container').on('click', '.add-custom-starting-company-championship-input-button', function () {

        // Get existing championships selects
        let parentBox = $(this).closest('.box');
        let championshipInputs = parentBox.find('.custom-starting-company-championship-name-input');

        // Check for maximum championships selects
        if (championshipInputs.length >= 10) {
            notie.alert({type: 3, text: 'You cannot add more than 10 championships'});
            return false;
        }

        // Clone championship input, add remove button
        let championshipInput = '<div class="margin-bottom-8">' + championshipInputs.eq(0).parent().clone().prop('innerHTML') +
            '<button type="button" class="remove-custom-starting-company-championship-input-button button retro-button styled-select-button ' +
            'font-bold top-1px margin-left-3"><i class="fa fa-minus"></i></button></div>';

        // Add championship input after last one
        championshipInputs.last().parent().after(championshipInput);

        // Reset graphic
        let addedInputParent = parentBox.find('.custom-starting-company-championship-name-input').last().parent();
        addedInputParent.find('.custom-starting-company-championship-remove-graphic-button').hide();
        addedInputParent.find('.custom-starting-company-championship-add-graphic-button').text('Add Graphic')
            .addClass('dark-grey-button-background').removeClass('blue-button-background');
        addedInputParent.data('key', null);
    });

    // Remove custom starting company championship input
    $('.custom-starting-company-container').on('click', '.remove-custom-starting-company-championship-input-button', function () {
        $(this).parent().remove();
        processCustomCompanyOpenGraphicCreator();
    });

    // Add/edit championship graphic
    $('.custom-starting-company-container').on('click', '.custom-starting-company-championship-add-graphic-button', function () {
        let parent = $(this).parent();

        processCustomCompanyOpenGraphicCreator();

        // Select this button
        $(this).text('Edit Graphic').removeClass('dark-grey-button-background').addClass('blue-button-background');

        // Show remove graphic button
        $(this).siblings('.custom-starting-company-championship-remove-graphic-button').show();

        // Set graphic data
        let jsonData;
        let graphicData;
        if (parent.data('key')) {
            jsonData = JSON.parse(parent.data('key'))
        }
        if (jsonData) {
            graphicData = [jsonData]
        }

        // Show graphic
        let graphicContainer = $(this).parent().siblings('.character-creator');
        let el = graphicContainer.find('.superstar-graphic');
        graphicContainer.show();
        showCustomStartingCompanyChampionshipGraphic(el, graphicData);
    });

    // Remove championship graphic
    $('.custom-starting-company-container').on('click', '.custom-starting-company-championship-remove-graphic-button', function () {
        let parent = $(this).parent();
        $(this).hide();

        processCustomCompanyOpenGraphicCreator();

        // Remove graphic data
        parent.data('key', null);
        parent.find('.custom-starting-company-championship-add-graphic-button').text('Add Graphic')
            .addClass('dark-grey-button-background').removeClass('blue-button-background');
    });

    // Show size select info
    $('.custom-starting-company-container').on('change', '.custom-starting-company-size-select', function () {
        let value = $(this).val();

        let companyReputation;
        let rosterCapacity;
        switch (value) {
            case 'backyard':
                companyReputation = 1;
                rosterCapacity = 20;
                break;
            case 'indie':
                companyReputation = 4;
                rosterCapacity = 45;
                break;
            case 'national':
                companyReputation = 7;
                rosterCapacity = 95;
                break;
            case 'global':
                companyReputation = 10;
                rosterCapacity = 180;
                break;
        }

        let companyInfoText = '<span class="margin-right-10 ">Company REP: {0}</span> Roster Capacity: {1}'.format(companyReputation, rosterCapacity);
        $('.custom-starting-company-size-info').html(companyInfoText);
    });

    // Show finances select info
    $('.custom-starting-company-container').on('change', '.custom-starting-company-finances-select', function () {
        let value = $(this).val();

        let points;
        switch (value) {
            case 'weak':
                points = 150;
                break;
            case 'average':
                points = 500;
                break;
            case 'strong':
                points = 2000;
                break;
            case 'loaded':
                points = 10000;
                break;
        }

        let financesInfoText = '<span class="blue"><img alt="Points" src="static/www/static/cp_icon.png" ' +
            'class="points-image-small margin-right-5"/>{0}</span>'.format(points.toLocaleString('en'));
        $('.custom-starting-company-finances-info').html(financesInfoText);
    });

    // Generate custom company button
    $('.custom-starting-company-container').on('click', '.custom-starting-company-generate-button', async function () {
        notie.confirm({text: 'Are you sure you want to generate company data? Any existing data will be overwritten.',
            submitCallback: async function () {
                await makeGameRequest(generateCustomStartingCompany, {}, showGenerateCustomStartingCompanyData, {}, false);
            }
        });
    });

    // Custom company back button
    $('.custom-starting-company-container').on('click', '.custom-starting-company-back-button', function () {
        notie.confirm({text: 'Are you sure?',
            submitCallback: function () {
                hideMainMenuContent($());
                $("#new-game-menu").fadeIn('slow');
                $("#scenario-filter-menu").fadeIn('slow');
            }
        });
    });
});

async function newGameMenuButtonHandler() {
    hideMainMenuContent($());

    // Get top rated scenarios
    getScenarios('top_rated');

    // Reset ui
    $("#scenario-filter-menu").fadeIn('slow');
    $('#scenario-filter-menu .scenario-filter').each(function () {
        $(this).removeClass('selected');
        if ($(this).attr('data-value') === 'top_rated') {
            $(this).addClass('selected')
        }
        $('.scenario-categories').hide();
        $('.scenario-categories-button').removeClass('selected');
        $('.scenario-search-container').hide();
        $('.scenario-search-button').removeClass('selected');
        $('.scenario-random-button').removeClass('selected');
        if (!globalUser.loggedIn && ['my-scenarios', 'favorite-scenarios'].includes($(this).attr('data-value'))) {
            $(this).hide();
        }
        else {
            $(this).show();
        }
    });
    $('.scenario-search-input').val('');
    $('.scenario-search-options input[name="radio-scenario-search-period"]:checked').val('any');
    $('.search-starting-year').val('');
    $('.search-company-name').val('');

    $("#new-game-menu").fadeIn('slow');
}

function getScenarios(filterName) {
    playSoundEffect('success');

    // Reset ui
    $("#our-scenarios").html('');
    $('#scenarios-search-results').html('').hide();
    $("#user-scenarios").html('');
    $("#tutorial-scenario").html('');
    $("#featured-scenario").html('');

    // Get scenarios data
    makeGetRequest('/_get_scenarios', {filter_name: filterName}, showGetScenariosData);
}

function showGetScenariosData(data) {
    let userScenariosHtml = '';
    let storyScenariosHtml = '';
    let tutorialScenarioHtml = '';
    let featuredScenarioHtml = '';

    // Add html for each scenario
    data['scenarios'].forEach(function (scenario) {
        let scenarioHtml = getScenarioHtml(scenario);
        if (scenario['story_name']) {
            if (scenario['story_name'] === 'tutorial') {
                tutorialScenarioHtml += scenarioHtml;
            }
            else {
                storyScenariosHtml += scenarioHtml;
            }
        }
        else if (scenario['category'] === 'featured') {
            featuredScenarioHtml += scenarioHtml;
        }
        else {
            userScenariosHtml += scenarioHtml;
        }
    });
    if (!data['scenarios'].length) {
        userScenariosHtml += '<div class="scenario">No scenarios found.</div>';
    }

    $('#our-scenarios').html(storyScenariosHtml).show();
    $("#user-scenarios").html(userScenariosHtml).show();
    $("#tutorial-scenario").html(tutorialScenarioHtml).show();
    $("#featured-scenario").html(featuredScenarioHtml).show();
}

function getScenarioHtml(scenario) {
    // Add competitors
    let competitors = '';
    let selectCompetitors = '';
    if (!scenario['story_name']) {
        if (scenario['competitors'].length > 0) {
            let competitorsOptions = '';
            if (!scenario['story_name']) {
                competitorsOptions = '<label class="control control--radio margin-right-10">Generate<input type="radio" name="radio-' +
                    scenario['uid'] + '" ' +
                    'value="generate" class="generate-competitors-radio"/><div class="control__indicator"></div></label>' +
                    '<label class="control control--radio help-text" title="Removes news and year-end awards.">' +
                    'None<input type="radio" name="radio-' +
                    scenario['uid'] + '" ' +
                    'value="none" class="none-competitors-radio"/><div class="control__indicator"></div></label>';
            }
            competitors = '<div class="margin-bottom-15 competitors"><span class="grey display-block margin-bottom-2">Competitors</span> ' +
                '<label class="control control--radio margin-right-10">' +
                '<span id="default-competition" data-value="' + scenario['competitors'].join(', ').replace(/"/g, "&quot;") + '">' +
                'Standard</span>' +
                '<input type="radio" name="radio-' +
                scenario['uid'] + '" value="standard" checked="checked" class="standard-competitors-radio"/><div class="control__indicator"></div></label>' +
                competitorsOptions +
                '</div>';
        } else {
            competitors = '<div class="margin-bottom-15 competitors"><span class="grey display-block margin-bottom-2">Competitors</span> ' +
                '<label class="control control--radio margin-right-10 display-none">' +
                '<span id="default-competition">' + '</span>' +
                '<input type="radio" name="radio-' +
                scenario['uid'] + '" value="standard" checked="checked" class="standard-competitors-radio"/><div class="control__indicator"></div></label>' +
                '<label class="control control--radio margin-right-10">Generate<input type="radio" name="radio-' +
                scenario['uid'] + '" ' +
                'checked="checked" value="generate" class="generate-competitors-radio"/><div class="control__indicator"></div></label>' +
                '<label class="control control--radio help-text" title="Removes news and year-end awards">' +
                'None<input type="radio" name="radio-' +
                scenario['uid'] + '" ' +
                'value="none" class="none-competitors-radio"/><div class="control__indicator"></div></label>' +
                '</div>';
        }
    }

    // Select competitors checkboxes
    let competitorCheckboxes = '';
    scenario['competitors'].forEach(function (competitor, i) {
        let checked = (i >= gameLimits.maxCompetitors) ? '' : ' checked="checked"';
        competitorCheckboxes += '<label class="control control--checkbox display-block">' +
            '<span class="select-competitor-name">' + escapeHTML(competitor) + '</span>' +
            '<input type="checkbox" class="select-competitor-checkbox" value="' + competitor.replace(/"/g, "&quot;") + '"' + checked + '>' +
            '    <div class="control__indicator"></div>' +
            '</label>';
    });

    let selectCompetitorsClass = (scenario['competitors'].length > 0) ? '' : ' display-none';
    if (!scenario['story_name']) {
        let moreCompetitorsInfo = '';
        if (scenario['competitors'].length > 10) {
            moreCompetitorsInfo = '<div class="margin-bottom-5 line-height-1p4 font-0p825em grey-blue-dark">' +
                '<i class="fa fa-info-circle margin-right-2"></i> ' +
                'Number of competitors will affect game load times.' +
                '</div>'
        }
        selectCompetitors = '<div class="margin-bottom-15 select-competitors' + selectCompetitorsClass + '">' +
            '<span class="grey display-block margin-bottom-2">Select Competitors</span> ' +
            moreCompetitorsInfo +
            '<div class="select-competitors-checkboxes">' + competitorCheckboxes + '</div>' +
            '</div>';
    }

    // Add versions
    let versions = '';
    let comments = '';

    if (scenario['versions'].length > 0 && !scenario['story_name'] && scenario['category'] !== 'featured') {
        let options = '';
        let commentDivs = '';
        scenario['versions'].forEach(function (version, i) {
            let versionCompanyName = version['company_name'];
            if (versionCompanyName) {
                versionCompanyName = versionCompanyName.replace(/"/g, "&quot;")
            }
            options += '<option value="' + version['version_number'] + '" data-competition=\'' +
                JSON.stringify(version['competition']).replace(/'/g, "&#39;") + '\' data-company-name="' + versionCompanyName + '">'
                + version['version_number'] + '</option>';
            // Hide all comments except those of latest version
            if (i !== 0) {
                if (version['comments']) {
                    commentDivs += '<div data-version="' + version['version_number'] + '" class="display-none">'
                        + escapeHTML(version['comments']) + '</div>';
                }
            } else {
                commentDivs += '<div data-version="' + version['version_number'] + '">' + escapeHTML(version['comments']) + '</div>';
            }
        });

        comments = '<div class="version-comments medium-grey">' + commentDivs + '</div>';

        versions = '<div class="margin-bottom-15 versions"><span class="grey margin-right-5 display-block margin-bottom-3">Version</span> ' +
            '<select id="select-version" title="Select Version" class="styled-select margin-bottom-15">' +
            options + '</select>' +
            comments +
            '</div>';
    }

    // Create edit
    let createEditButton = '';
    if (!scenario['story_name']) {
        if (scenario['allow_edits']) {
            if (globalUser.paid) {
                createEditButton = '<button type="button" class="button retro-button condensed dark-grey-button-background ' +
                    'margin-left-5 create-scenario-edit">Create Edit</button>';
            } else {
                createEditButton = '<button type="button" class="button retro-button condensed dark-grey-button-background ' +
                    'margin-left-5 create-scenario-edit disabled help-text" title="Creating edits is only available in JoW Paid">Create Edit</button>';
            }
        } else {
            createEditButton = '<button type="button" class="button retro-button condensed dark-grey-button-background ' +
                'margin-left-5 create-scenario-edit disabled help-text" title="The creator has disabled creating edits for this scenario">Create Edit</button>';
        }
    }

    // Edits
    let editsHtml = '';
    if (!scenario['story_name']) {
        editsHtml =
            '<div class="margin-bottom-15">' +
            '<div class="margin-bottom-10">' +
            '<button type="button" class="button retro-button condensed dark-grey-button-background scenario-edits-show-button">Show Edits</button>' +
            createEditButton +
            '</div>' +
            '<div class="scenario-edits-container display-none">' +
            '</div>' +
            '</div>';
    }

    // Starting company
    let startingCompany = '';
    if (scenario['competitors'].length > 0 && !scenario['story_name']) {
        let options = '';
        options += '<option selected data-default="true" value="">' + escapeHTML(scenario['company_name']) + '</option>';
        scenario['competitors'].forEach(function (competitor) {
            options += '<option value="' + competitor.replace(/"/g, "&quot;") + '">' + escapeHTML(competitor) + '</option>';
        });

        startingCompany = '<div class="margin-bottom-15 starting-company">' +
            '<span class="margin-right-5 display-block margin-bottom-3 grey">Starting Company</span> ' +
            '<select id="select-starting-company" title="Select Starting Company" ' +
            'class="styled-select" data-value="' + scenario['company_name'].replace(/"/g, "&quot;") + '">' +
            options + '</select>' +
            '</div>';
    }

    // Player Mode
    let playerMode = '';
    if (scenario['competitors'].length > 0 && !scenario['story_name']) {
        let playerModeDisabled = '';
        let playerModeHelpText = 'Local Multiplayer allows you to book multiple companies in your game.';
        if (!globalUser.paid) {
            playerModeDisabled = ' disabled';
            playerModeHelpText += ' (JoW Paid)';
        }
        playerMode = '<div class="margin-bottom-15 player-mode-option">' +
            '<span class="grey display-block margin-bottom-3">Player Mode</span> ' +
            '<label class="control control--radio margin-right-10">Singleplayer<input type="radio" name="radio-player-mode-option-' +
            scenario['uid'] + '" ' +
            'checked="checked" value="singleplayer"/><div class="control__indicator"></div></label>' +
            '<label class="control control--radio help-text' + playerModeDisabled + '" title="' + playerModeHelpText + '">' +
            'Local Multiplayer<input type="radio" name="radio-player-mode-option-' +
            scenario['uid'] + '" ' +
            'value="local-multiplayer"' + playerModeDisabled + '/><div class="control__indicator"></div></label>' +
            '</div>'
    }

    // Custom starting company
    let customStartingCompany = '';
    if (!scenario['story_name']) {
        let customStartingCompanyDisabled = '';
        let customStartingCompanyHelpText = 'Custom Starting Company allows you to start the game controlling a custom company that you create.';
        if (!globalUser.paid) {
            customStartingCompanyDisabled = ' disabled';
            customStartingCompanyHelpText += ' (JoW Paid)';
        }
        customStartingCompany = '<div class="margin-bottom-15 custom-starting-company-option">' +
            '<span class="grey display-block margin-bottom-3">Custom Starting Company</span> ' +
            '<label class="control control--radio margin-right-10 help-text' + customStartingCompanyDisabled +
            '" title="' + customStartingCompanyHelpText + '">Yes<input type="radio" name="radio-custom-starting-company-option-' +
            scenario['uid'] + '" ' +
            'value="yes"' + customStartingCompanyDisabled + '/><div class="control__indicator"></div></label>' +
            '<label class="control control--radio">' +
            'No<input type="radio" name="radio-custom-starting-company-option-' +
            scenario['uid'] + '" ' +
            'value="no" checked="checked"/><div class="control__indicator"></div></label>' +
            '</div>'
    }

    // Companies List
    let companiesList = '';
    if (globalUser.paid && scenario['competitors'].length > 0 && !scenario['story_name']) {
        let companiesListHtml =
            '<span class="grey display-block margin-bottom-3">Companies</span> ' +
            '<div class="margin-top-8 company-list-item">' +
            '<span class="medium-dark-grey margin-bottom-2 display-block company-list-item-name">' + escapeHTML(scenario['company_name']) + '</span>' +
            '<label class="control control--radio margin-right-10">User<input type="radio" name="radio-company-list-item-' +
            scenario['uid'] + '-' + scenario['company_name'] + '" ' +
            'checked="checked" value="user"/><div class="control__indicator"></div></label>' +
            '<label class="control control--radio margin-right-10">CPU<input type="radio" name="radio-company-list-item-' +
            scenario['uid'] + '-' + scenario['company_name'] + '" ' +
            'value="CPU"/><div class="control__indicator"></div></label>' +
            '<label class="control control--radio">None<input type="radio" name="radio-company-list-item-' +
            scenario['uid'] + '-' + scenario['company_name'] + '" ' +
            'value="none"/><div class="control__indicator"></div></label>' +
            '<input type="text" name="company-list-item-player-name" placeholder="Player Name" maxlength="15" class="styled-select player-name-input">' +
            '</div>';
        scenario['competitors'].forEach(function (competitor, i) {
            if (i < gameLimits.maxCompetitors) {
                companiesListHtml +=
                    '<div class="margin-top-8 company-list-item">' +
                    '<span class="medium-dark-grey margin-bottom-2 display-block company-list-item-name">' + escapeHTML(competitor) + '</span>' +
                    '<label class="control control--radio margin-right-10">User<input type="radio" name="radio-company-list-item-' +
                    scenario['uid'] + '-' + escapeHTML(competitor) + '" ' +
                    'value="user"/><div class="control__indicator"></div></label>' +
                    '<label class="control control--radio margin-right-10">CPU<input type="radio" name="radio-company-list-item-' +
                    scenario['uid'] + '-' + escapeHTML(competitor) + '" ' +
                    'checked="checked" value="CPU"/><div class="control__indicator"></div></label>' +
                    '<label class="control control--radio">None<input type="radio" name="radio-company-list-item-' +
                    scenario['uid'] + '-' + escapeHTML(competitor) + '" ' +
                    'value="none"/><div class="control__indicator"></div></label>' +
                    '<input type="text" name="company-list-item-player-name" placeholder="Player Name" maxlength="15" class="styled-select player-name-input display-none">' +
                    '</div>';
            } else {
                companiesListHtml +=
                    '<div class="margin-top-8 company-list-item">' +
                    '<span class="medium-dark-grey margin-bottom-2 display-block company-list-item-name">' + escapeHTML(competitor) + '</span>' +
                    '<label class="control control--radio margin-right-10">User<input type="radio" name="radio-company-list-item-' +
                    scenario['uid'] + '-' + escapeHTML(competitor) + '" ' +
                    'value="user"/><div class="control__indicator"></div></label>' +
                    '<label class="control control--radio margin-right-10">CPU<input type="radio" name="radio-company-list-item-' +
                    scenario['uid'] + '-' + escapeHTML(competitor) + '" ' +
                    'value="CPU"/><div class="control__indicator"></div></label>' +
                    '<label class="control control--radio">None<input type="radio" name="radio-company-list-item-' +
                    scenario['uid'] + '-' + escapeHTML(competitor) + '" ' +
                    'checked="checked" value="none"/><div class="control__indicator"></div></label>' +
                    '<input type="text" name="company-list-item-player-name" placeholder="Player Name" maxlength="15" class="styled-select player-name-input display-none">' +
                    '</div>';
            }
        });
        companiesList = '<div class="margin-bottom-15 companies-list display-none">' + companiesListHtml + '</div>';
    }

    // Scenario rating
    let ratingSpan = '';
    if (scenario['story_name'] !== 'tutorial') {
        if (scenario['rating'] === null) {
            ratingSpan = '<span class="rating no-rating">No ratings yet</span>'
        } else {
            if (scenario['rating'] >= 50) {
                ratingSpan = '<span class="rating positive">' + scenario['rating'] + '%</span>'
            } else {
                ratingSpan = '<span class="rating negative">' + scenario['rating'] + '%</span>'
            }
        }
    }

    // Weekly shows option
    let weeklyShowsOption = '';
    if (!scenario['story_name']) {
        weeklyShowsOption = '<div class="margin-bottom-15 run-weekly-shows">' +
            '<span class="grey display-block margin-bottom-3">Run Weekly Shows</span> ' +
            '<label class="control control--radio margin-right-10">Yes<input type="radio" name="radio-run-weekly-shows' +
            scenario['uid'] + '" ' +
            'checked="checked" value="yes"/><div class="control__indicator"></div></label>' +
            '<label class="control control--radio">No<input type="radio" name="radio-run-weekly-shows' +
            scenario['uid'] + '" ' +
            'value="no"/><div class="control__indicator"></div></label>' +
            '</div>'
    }

    // Draft option
    let draftOption = '';
    if (!scenario['story_name'] && scenario['competitors'].length > 0) {
        draftOption = '<div class="margin-bottom-15 main-rosters-option">' +
            '<span class="grey display-block margin-bottom-3">Main Rosters</span> ' +
            '<label class="control control--radio margin-right-10">Default' +
            '<input type="radio" name="radio-main-rosters-option' +
            scenario['uid'] + '" ' +
            'checked="checked" value="default"/><div class="control__indicator"></div></label>' +
            '<label class="control control--radio help-text" ' +
            'title="All companies draft new rosters from all Superstars">Draft<input type="radio" name="radio-main-rosters-option' +
            scenario['uid'] + '" ' +
            'value="draft"/><div class="control__indicator"></div></label>' +

            '<div class="margin-top-15 draft-options display-none">' +
            '<span class="grey display-block margin-bottom-3">Draft Options</span> ' +

            '<label class="control control--checkbox display-block">' +
            '<span class="select-draft-options help-text" title="Also includes talent from unselected competitors">Include Indie Roster</span>' +
            '<input type="checkbox" class="select-draft-options-checkbox" value="include_indie_roster" checked>' +
            '<div class="control__indicator"></div>' +
            '</label>' +
            '<label class="control control--checkbox display-block">' +
            '<span class="select-draft-options help-text" title="Also includes training talent from unselected competitors">Include Training Rosters</span>' +
            '<input type="checkbox" class="select-draft-options-checkbox" value="include_training_rosters" checked>' +
            '<div class="control__indicator"></div>' +
            '</label>' +
            '</div>' +

            '</div>'
    }

    // Game Mode option
    let gameModeOption = '';
    if (!scenario['story_name']) {
        let sandboxModeDisabled = '';
        let sandboxHelpText = 'Sandbox Mode removes most of the game\'s restrictions, allowing you to book freely.';
        if (!globalUser.paid) {
            sandboxModeDisabled = ' disabled';
            sandboxHelpText += ' (JoW Paid)';
        }
        gameModeOption = '<div class="margin-bottom-15 game-mode-option">' +
            '<span class="grey display-block margin-bottom-3">Game Mode</span> ' +
            '<label class="control control--radio margin-right-10">Normal' +
            '<input type="radio" name="radio-game-mode-option' +
            scenario['uid'] + '" ' +
            'checked="checked" value="normal"/><div class="control__indicator"></div></label>' +
            '<label class="control control--radio help-text' + sandboxModeDisabled + '" ' +
            'title="' + sandboxHelpText + '">Sandbox<input type="radio" name="radio-game-mode-option' +
            scenario['uid'] + '" ' +
            'value="sandbox"' + sandboxModeDisabled + '/><div class="control__indicator"></div></label>' +

            '<div class="margin-top-15 sandbox-mode-options display-none">' +
            '<span class="grey display-block margin-bottom-3">Sandbox Options</span> ' +

            '<label class="control control--checkbox display-block">' +
            '<span class="select-sandbox-options">Unlimited Creative Points</span>' +
            '<input type="checkbox" class="select-sandbox-options-checkbox" value="unlimited_creative_points" checked>' +
            '<div class="control__indicator"></div>' +
            '</label>' +
            '<label class="control control--checkbox display-block">' +
            '<span class="select-sandbox-options">Highest Roster Capacity</span>' +
            '<input type="checkbox" class="select-sandbox-options-checkbox" value="maximum_roster_capacity" checked>' +
            '<div class="control__indicator"></div>' +
            '</label>' +
            '<label class="control control--checkbox display-block">' +
            '<span class="select-sandbox-options">All Indies Available</span>' +
            '<input type="checkbox" class="select-sandbox-options-checkbox" value="all_indies_available" checked>' +
            '<div class="control__indicator"></div>' +
            '</label>' +
            '<label class="control control--checkbox display-block">' +
            '<span class="select-sandbox-options">Unlock All Items</span>' +
            '<input type="checkbox" class="select-sandbox-options-checkbox" value="unlock_all_items" checked>' +
            '<div class="control__indicator"></div>' +
            '</label>' +
            '<label class="control control--checkbox display-block">' +
            '<span class="select-sandbox-options">Maximum Staff & Facilities</span>' +
            '<input type="checkbox" class="select-sandbox-options-checkbox" value="maximum_staff_and_facilities" checked>' +
            '<div class="control__indicator"></div>' +
            '</label>' +
            '<label class="control control--checkbox display-block">' +
            '<span class="select-sandbox-options">No Special Items Cooldown</span>' +
            '<input type="checkbox" class="select-sandbox-options-checkbox" value="no_special_items_cooldown" checked>' +
            '<div class="control__indicator"></div>' +
            '</label>' +
            '<label class="control control--checkbox display-block">' +
            '<span class="select-sandbox-options">No Injuries</span>' +
            '<input type="checkbox" class="select-sandbox-options-checkbox" value="no_injuries" checked>' +
            '<div class="control__indicator"></div>' +
            '</label>' +
            '<label class="control control--checkbox display-block">' +
            '<span class="select-sandbox-options">No Unhappiness</span>' +
            '<input type="checkbox" class="select-sandbox-options-checkbox" value="no_unhappiness" checked>' +
            '<div class="control__indicator"></div>' +
            '</label>' +
            '<label class="control control--checkbox display-block">' +
            '<span class="select-sandbox-options">No Talent Requests</span>' +
            '<input type="checkbox" class="select-sandbox-options-checkbox" value="no_talent_requests">' +
            '<div class="control__indicator"></div>' +
            '</label>' +
            '<label class="control control--checkbox display-block">' +
            '<span class="select-sandbox-options">No Random Events</span>' +
            '<input type="checkbox" class="select-sandbox-options-checkbox" value="no_random_events">' +
            '<div class="control__indicator"></div>' +
            '</label>' +
            '<label class="control control--checkbox display-block">' +
            '<span class="select-sandbox-options">No Retirements</span>' +
            '<input type="checkbox" class="select-sandbox-options-checkbox" value="no_retirements">' +
            '<div class="control__indicator"></div>' +
            '</label>' +
            '<label class="control control--checkbox display-block">' +
            '<span class="select-sandbox-options">No Going Part-Time</span>' +
            '<input type="checkbox" class="select-sandbox-options-checkbox" value="no_going_part_time">' +
            '<div class="control__indicator"></div>' +
            '</label>' +
            '</div>' +

            '</div>'
    }

    // Check if user has rated scenario
    let rating = '';
    if (scenario['story_name'] !== 'tutorial') {
        if (scenario['rated_up']) {
            rating = '<i class="fa fa-thumbs-o-up icon-button margin-left-10 rate-up font-bold positive"></i>' +
                '<i class="fa fa-thumbs-o-down icon-button margin-left-8 rate-down"></i>'
        } else if (scenario['rated_down']) {
            rating = '<i class="fa fa-thumbs-o-up icon-button margin-left-10 rate-up"></i>' +
                '<i class="fa fa-thumbs-o-down icon-button margin-left-8 rate-down font-bold negative"></i>'
        } else {
            rating = '<i class="fa fa-thumbs-o-up icon-button margin-left-10 rate-up"></i>' +
                '<i class="fa fa-thumbs-o-down icon-button margin-left-8 rate-down"></i>';
        }
    }

    // Scenario plays
    let plays = '';
    if (scenario['story_name'] !== 'tutorial') {
        let playsSuffix = ' plays';
        if (scenario['count'] === 1) {
            playsSuffix = ' play'
        }
        plays = '<span class="margin-left-10 light-grey">' +
            scenario['count'].toLocaleString('en') + playsSuffix +
            '</span>';
    }

    // Add update button
    let update = '';
    if (scenario['edit']) {
        update = '<button type="button" class="button retro-button display-inline-block margin-top-5 margin-right-5 dark-grey-button-background ' +
            'edit-scenario">Update</button>';
    }

    // Add duplicate button
    let duplicateButtonHtml = '';
    if (scenario['edit']) {
        duplicateButtonHtml = '<button type="button" class="button retro-button display-inline-block margin-top-5 margin-right-5 dark-grey-button-background ' +
            'duplicate-scenario-button">Duplicate</button>';
    }

    // Add show info button
    let showInfoButton = '<button type="button" class="button retro-button display-inline-block show-scenario-information' +
        ' grey-button-background margin-top-7">More Info</button>';

    // Add delete button
    let deleteButton = '';
    if (scenario['delete']) {
        deleteButton = '<button type="button" class="button retro-button display-inline-block margin-top-5 margin-right-5 red-button-background ' +
            'delete-scenario">Delete</button>'
    }

    // Add play button
    let play = '<button type="button" class="button retro-button display-inline-block play-scenario margin-right-5">Play</button>';

    // Add border for stories
    let scenarioClass = '';
    let scenarioStats = '';
    if (scenario['story_name'] === 'mars') {
        scenarioClass = ' mars';
    } else if (scenario['story_name'] === 'passion') {
        scenarioClass = ' passion';
    } else if (scenario['story_name'] === 'tutorial') {
        scenarioClass = ' tutorial';
    } else if (scenario['category'] === 'featured') {
        scenarioClass = ' featured';
    }

    if (!scenario['story_name'] && scenario['category'] !== 'featured') {
        let scenarioCreator = '<span class="grey">' + escapeHTML(scenario['creator']) + '</span>';
        if (!scenarioCreator) {
            scenarioCreator = 'unknown'
        }
        scenarioStats = 'Created by ' + scenarioCreator;
    }

    // Datetime created/last updated
    let lastUpdatedHtml = '';
    let datetimeUpdated = '';
    if (scenario['datetime_updated_string'] && !scenario['story_name'] && scenario['category'] !== 'featured') {
        lastUpdatedHtml = '<span class="display-block margin-top-2">' +
            'Last updated on <span class="grey">' + scenario['datetime_updated_string'] + '</span></span>';
        datetimeUpdated = scenario['datetime_updated_string'];
    }
    if (scenario['datetime_created_string'] && !scenario['story_name'] && scenario['category'] !== 'featured') {
        scenarioStats += ' on <span class="grey">' + scenario['datetime_created_string'] + '</span>';
    }

    // Sorting attributes
    let confidence = '';
    if (scenario['confidence']) {
        confidence = scenario['confidence']
    }

    // Check if private scenario
    let privateHtml = '';
    if (scenario['private']) {
        privateHtml = '<div class="brown-red margin-top-2">Private</div>'
    }

    // Add starting event
    let startEventHtml = '';
    let startingMonthName = '';
    if (scenario['starting_month'] !== undefined) {
        startingMonthName = monthNames[scenario['starting_month']]
    }
    if (scenario['starting_event'] && !scenario['story_name']) {
        startEventHtml = '<span class="display-block">Starts at <span class="grey">{0}, {1} {2}</span></span>'.format(escapeHTML(scenario['starting_event']),
            startingMonthName, scenario['starting_year'])
    }

    let html = '';

    // If story and user not paid, don't show play button, add help text
    if ((scenario['story_name'] && scenario['story_name'] !== 'tutorial' && !globalUser.paid) || (scenario['story_name'] === 'passion' && globalUser.freeTrialActivated)) {
        let scenarioHelpText;
        if (scenario['story_name'] === 'passion' && globalUser.freeTrialActivated) {
            scenarioHelpText = "This story is not available in the Free Trial."
        } else {
            scenarioHelpText = "This story is only available in JoW Paid."
        }
        html = '<div class="scenario' + scenarioClass + ' disabled help-text" data-myscenario="' +
            scenario['my_scenario'] + '" data-uid="' +
            scenario['uid'] + '" title="' + scenarioHelpText + '">' +
            '<span class="display-block margin-bottom-6 font-22px font-mukta-mahee line-height-1p4">' + escapeHTML(scenario['name']) + '</span>' +
            '<span class="display-block margin-bottom-15">' + ratingSpan + plays +
            '</span>' +
            '<span class="display-block margin-bottom-15 description medium-grey">' +
            escapeHTML(scenario['description']) +
            '</span>' +
            '</div>';
    } else {
        let featuredUrl = scenario['category'] === 'featured' ? '<span> Share your DPW Forever card to <a href="https://twitter.com/JowMahin/status/1760239605746368606" target="_blank">win</a> a DPW on demand subscription or a JoW t-shirt / JoW Paid!</span>' : '';
        html = '<div class="scenario' + scenarioClass + '" data-myscenario="' + scenario['my_scenario'] + '" data-uid="' +
            scenario['uid'] + '" data-plays="' + scenario['count'] + '" data-rating="' +
            confidence + '" data-updated="' + datetimeUpdated + '">' +
            '<span class="display-block margin-bottom-6 font-22px font-mukta-mahee line-height-1p4">' + escapeHTML(scenario['name']) + '</span>' +
            '<span class="display-block margin-bottom-15">' + ratingSpan +
            rating + plays +
            '</span>' +
            '<span class="display-block margin-bottom-15 description medium-grey">' +
            escapeHTML(scenario['description']) + featuredUrl +
            '<div class="medium-light-grey font-0p925em line-height-1p4 margin-top-15">' +
            startEventHtml +
            '<span class="display-block creator margin-top-2">' + scenarioStats + '</span>' +
            lastUpdatedHtml +
            privateHtml +
            '</div>' +
            '</span>' +
            versions +
            editsHtml +
            playerMode + companiesList + startingCompany + customStartingCompany + competitors + selectCompetitors + weeklyShowsOption +
            draftOption + gameModeOption +
            play + update + duplicateButtonHtml + deleteButton + showInfoButton +
            '</div>';
    }

    return html;
}

async function playScenarioHandler(el) {
    playSoundEffect('success');

    // Get uid of scenario or edit, if selected
    let uid = el.parent('.scenario').attr('data-uid');
    let scenarioEdit = el.parent('.scenario').find('.scenario-edit.selected');
    if (scenarioEdit.length > 0) {
        uid = scenarioEdit.attr('data-uid')
    }

    let version = el.siblings('.versions').find('#select-version').val();

    let gameSettings = getNewGameSettings(el);
    if (!gameSettings) {
        return false;
    }

    if (el.parent().hasClass('mars')) {
        notie.alert({type: 3, text: "This story is not available yet and will be added soon."});
        return false;
    }

    // Load custom starting company page if selected
    if (el.siblings('.custom-starting-company-option').find('input[type="radio"]:checked').val() === 'yes') {
        // Reset inputs
        let parent = $('.custom-starting-company-container');
        parent.find('input:not([type="checkbox"])').val('');
        parent.find('.custom-starting-company-size-select').val('indie');
        parent.find('.custom-starting-company-finances-select').val('average');
        parent.find('.custom-starting-company-talent-select').val('generate');
        parent.find('.custom-starting-company-training-roster-select').val('generate');
        parent.find('.custom-starting-company-event-prestige-select').val('C');
        parent.find('.custom-starting-company-championship-division-select').val('singles');
        parent.find('.custom-starting-company-championship-prestige-select').val('C');
        parent.find('.custom-starting-company-style-select').val('entertainment');
        parent.find('input[value="include_company_rosters"]').prop('checked', true);
        parent.find('input[value="include_indie_roster"]').prop('checked', true);
        parent.find('input[value="protect_company_talent"]').prop('checked', false);

        // Trigger inputs/selects
        $('.custom-starting-company-size-select').trigger('change');
        $('.custom-starting-company-finances-select').trigger('change');
        $('.custom-starting-company-talent-select').trigger('change');

        // Remove extra championship inputs, reset first
        let championshipInputs = parent.find('.custom-starting-company-championship-name-input');
        championshipInputs.slice(1).parent().remove();
        parent.find('.custom-starting-company-championship-remove-graphic-button').hide();
        parent.find('.custom-starting-company-championship-add-graphic-button').text('Add Graphic')
            .addClass('dark-grey-button-background').removeClass('blue-button-background');
        parent.find('.custom-starting-company-championship-name-input').parent().data('key', null);

        // Hide graphic creator
        parent.find('.character-creator').hide();
        parent.find('.character-creator').find('.superstar-graphic').html('');

        // Show custom starting company page
        notie.hideAlerts();
        hideMainMenuContent($());
        $('.custom-starting-company-container').fadeIn('slow');

        // Play custom company button
        $('.custom-starting-company-container').off('click', '#custom-starting-company-play-button');
        $('.custom-starting-company-container').on('click', '#custom-starting-company-play-button', async function () {

            // Get input values
            let parent = $('.custom-starting-company-container');
            let companyName = parent.find('.custom-starting-company-name-input').val();
            let companySize = parent.find('.custom-starting-company-size-select').val();
            let companyFinances = parent.find('.custom-starting-company-finances-select').val();
            let talentOption = parent.find('.custom-starting-company-talent-select').val();
            let trainingRosterOption = parent.find('.custom-starting-company-training-roster-select').val();
            let weeklyShowName = parent.find('.custom-starting-company-weekly-show-name-input').val();
            let ownerName = parent.find('.custom-starting-company-owner-name-input').val();
            let companyStyle = parent.find('.custom-starting-company-style-select').val();
            let draftIncludeCompanyRosters = parent.find('.custom-starting-company-draft-options').find('input[value="include_company_rosters"]').prop('checked');
            let draftIncludeIndies = parent.find('.custom-starting-company-draft-options').find('input[value="include_indie_roster"]').prop('checked');
            let draftProtectCompanyTalent = parent.find('.custom-starting-company-draft-options').find('input[value="protect_company_talent"]').prop('checked');

            // Get event and championship names and prestiges
            let companyMonthlyEventsData = [];
            parent.find('.custom-starting-company-event-name-input').each(function (i, e) {
                let eventName = $(e).val();
                let eventPrestige = $(e).next('.custom-starting-company-event-prestige-select').val();
                let companyMonthlyEventData = {
                    'name': eventName,
                    'prestige': eventPrestige
                }
                companyMonthlyEventsData.push(companyMonthlyEventData);
            });

            processCustomCompanyOpenGraphicCreator(false);
            let companyChampionshipsData = [];
            parent.find('.custom-starting-company-championship-name-input').each(function (i, e) {
                let championshipName = $(e).val();
                if (championshipName) {
                    let championshipDivision = $(e).siblings('.custom-starting-company-championship-division-select').val();
                    let championshipPrestige = $(e).siblings('.custom-starting-company-championship-prestige-select').val();
                    let championshipGraphicData = $(e).parent().data('key');
                    let companyChampionshipData = {
                        'name': championshipName,
                        'division': championshipDivision,
                        'prestige': championshipPrestige,
                        'graphic': championshipGraphicData
                    }
                    companyChampionshipsData.push(companyChampionshipData);
                }
            });

            // Validate inputs
            if (companyName.length <= 0) {
                notie.alert({type: 3, text: "Please enter the Company's name"});
                return false;
            }
            if (talentOption === 'draft') {
                if (!draftIncludeCompanyRosters && !draftIncludeIndies) {
                    notie.alert({type: 3, text: "You need to include either company or indie talent in the draft"});
                    return false;
                }
            }
            let emptyMonthlyEventName = false;
            companyMonthlyEventsData.forEach(function(monthlyEventData) {
                if (!monthlyEventData['name']) {
                    emptyMonthlyEventName = true;
                }
            });
            if (emptyMonthlyEventName) {
                notie.alert({type: 3, text: "Please enter all Monthly Event names"});
                return false;
            }

            // Get custom starting company data
            let draftSettings = {
                'includeCompanyRosters': draftIncludeCompanyRosters, 'includeIndies': draftIncludeIndies,
                'protectCompanyTalent': draftProtectCompanyTalent
            }
            gameSettings['customStartingCompanyData'] = {
                'companyName': companyName, 'companySize': companySize,
                'companyFinances': companyFinances, 'talentOption': talentOption, 'trainingRosterOption': trainingRosterOption,
                'weeklyShowName': weeklyShowName, 'ownerName': ownerName,
                'companyMonthlyEventsData': companyMonthlyEventsData, 'companyChampionshipsData': companyChampionshipsData,
                'companyStyle': companyStyle, 'draftSettings': draftSettings
            };

            await makePlayScenarioRequest(uid, version, gameSettings);
        });

        // Show draft options
        $('.custom-starting-company-container').off('change', '.custom-starting-company-talent-select');
        $('.custom-starting-company-container').on('change', '.custom-starting-company-talent-select', function () {
            let value = $(this).val();

            if (value === 'draft') {
                $('.custom-starting-company-draft-options').show();
                if (el.siblings('.main-rosters-option').find('input[type="radio"]:checked').val() === 'draft') {
                    $('.custom-starting-company-draft-info-content').text('Talent Draft settings are not used when ' +
                        'Main Rosters Draft is also selected. Instead of a single company draft, all companies ' +
                        'take part in the draft.');
                    $('.custom-starting-company-draft-options input').attr('disabled', true);
                }
                else {
                    $('.custom-starting-company-draft-info-content').text('A single company draft will run with the following settings:');
                    $('.custom-starting-company-draft-options input').attr('disabled', false)
                }
            }
            else {
                $('.custom-starting-company-draft-options').hide()
            }
        });

        return false;
    }

    await makePlayScenarioRequest(uid, version, gameSettings);
}

async function makePlayScenarioRequest(uid, version, gameSettings) {
    if (globals.requestRunning) {
        return false;
    }
    let userGames = JSON.parse(window.localStorage.getItem("jowGames")) || [];
    if (!globalUser.paid && userGames.length > 0) {
        notie.alert({
            type: 3, text: 'Free users are limited to one save. Please delete your current save to create a new one.',
            stay: true
        });
        return false;
    }
    const user = loadUser();
    const loadFavoriteCommunitySegments = user.settings['loadFavoriteCommunitySegments'];
    makeGetRequest('/_get_scenario_export_data', {uid: uid, version: version,
            loadFavoriteCommunitySegments: loadFavoriteCommunitySegments},
        async (data) => {
            await checkGetScenarioExportDataJob(data['statusUrl'], gameSettings, uid);
        }, true);
}

async function checkGetScenarioExportDataJob(statusUrl, gameSettings, uid) {
    makeGetRequest(statusUrl, {}, async (data) => {
        switch (data.status) {
            case "unknown":
            case "failed":
                notie.hideAlerts();
                globals.requestRunning = false;

                notie.alert({type: 3, text: "There was an error. Please try again"});
                break;
            case "finished":
                notie.hideAlerts();
                globals.requestRunning = false;

                // Don't load if html tags found
                const regex = /(<[^>]*>)|(&lt;)|(\/script)|(src=)|(&#)|(onfocus=)/i;
                const regexResult = JSON.stringify(data['result']).match(regex);
                if (regexResult) {
                    notie.alert({type: 3, text: "HTML tags were found within the scenario. For security purposes, the scenario wasn't loaded."})
                    return false;
                }

                await makeGameRequest(createGameFromScenarioData, {scenarioData: data['result'], gameSettings},
                    showCreateNewGameFromScenarioDataData, {uid}, false, true);

                break;
            default:
                setTimeout(async function () {
                    await checkGetScenarioExportDataJob(statusUrl, gameSettings, uid);
                }, 1000);
        }
    }, true, null, false);
}


function getNewGameSettings(el) {
    let gameSettings = {};
    gameSettings['competitorsOption'] = el.siblings('.competitors').find('input[type="radio"]:checked').val();
    gameSettings['startingCompanyName'] = el.siblings('.starting-company').find('#select-starting-company').val();
    gameSettings['numberOfWeeklyShows'] = el.siblings('.run-weekly-shows').find('input[type="radio"]:checked').val() === 'no' ? 0 : 2;
    gameSettings['mainRostersOption'] = el.siblings('.main-rosters-option').find('input[type="radio"]:checked').val();
    gameSettings['gameModeOption'] = el.siblings('.game-mode-option').find('input[type="radio"]:checked').val();
    gameSettings['draftIncludeIndies'] = el.siblings('.main-rosters-option').find('.draft-options input[value="include_indie_roster"]').prop('checked');
    gameSettings['draftIncludeTraining'] = el.siblings('.main-rosters-option').find('.draft-options input[value="include_training_rosters"]').prop('checked');

    // Get selected competitors
    let selectedCompetitorsDiv = el.siblings('.select-competitors');
    if (selectedCompetitorsDiv.length > 0 && selectedCompetitorsDiv.is(":visible")) {
        let selectedCompetitors = [];
        selectedCompetitorsDiv.find('input').each(function(i, selectedCompetitorInput) {
            if ($(selectedCompetitorInput).is(":checked")) {
                selectedCompetitors.push($(selectedCompetitorInput).val());
            }
        });
        gameSettings['selectedCompetitorsNames'] = selectedCompetitors;
    }

    // Get sandbox mode options
    let sandboxModeOptionsDiv = el.siblings('.game-mode-option').find('.sandbox-mode-options');
    if (sandboxModeOptionsDiv.length > 0 && sandboxModeOptionsDiv.is(":visible")) {
        let sandboxModeOptions = [];
        sandboxModeOptionsDiv.find('input').each(function(i, sandboxModeOptionInput) {
            if ($(sandboxModeOptionInput).is(":checked")) {
                sandboxModeOptions.push($(sandboxModeOptionInput).val());
            }
        });

        if (!sandboxModeOptions.length) {
            notie.alert({
                type: 3, text: 'You need to select at least 1 of the options for Sandbox Mode'
            });
            return false;
        }

        gameSettings['sandboxModeOptions'] = sandboxModeOptions;
    }

    // Get local multiplayer mode options
    gameSettings['playerModeOption'] = el.siblings('.player-mode-option').find('input[type="radio"]:checked').val();
    if (gameSettings['playerModeOption'] === 'local-multiplayer') {
        let companiesListElement = el.siblings('.companies-list');
        let selectedUserCompaniesArray = [];
        let selectedCPUCompaniesArray = [];
        let playerNamesArray = [];

        // Add user and CPU companies
        companiesListElement.find('input[type="radio"]:checked').each(function (i, selectedCompanyInput) {
            let selectedCompanyInputValue = $(selectedCompanyInput).val();
            if (selectedCompanyInputValue === 'user') {
                selectedUserCompaniesArray.push($(selectedCompanyInput).closest('.company-list-item')
                    .find('.company-list-item-name').text());

                // Add player names for user companies
                let selectedCompanyInputPlayerName = $(selectedCompanyInput).closest('.company-list-item')
                    .find('.player-name-input').val();
                playerNamesArray.push(selectedCompanyInputPlayerName);
            }
            else if (selectedCompanyInputValue === 'CPU') {
                selectedCPUCompaniesArray.push($(selectedCompanyInput).closest('.company-list-item')
                    .find('.company-list-item-name').text());
            }
        });

        // Check if at least 2 user companies have been selected
        if (selectedUserCompaniesArray.length < 2) {
            notie.alert({type: 3, text: "You need to select at least 2 user controlled companies for local multiplayer"});
            return false;
        }

        gameSettings['selectedUserCompanies'] = selectedUserCompaniesArray;
        gameSettings['selectedCPUCompanies'] = selectedCPUCompaniesArray;
        gameSettings['playerNames'] = playerNamesArray;

        // Set other options
        gameSettings['competitorsOption'] = 'standard';
    }

    return gameSettings;
}

async function showCreateNewGameFromScenarioDataData({data, uid} = {}) {
    if (!data['error']) {
        // Save times played for scenario if online
        if (window.navigator.onLine) {
            $.ajax({
                url: globals.baseUrl + '/_add_scenario_times_played',
                dataType: 'json',
                data: {uid: uid},
                success: () => {}
            });
        }

        // Go to created game
        await goToGameFromMainMenu(data['createdGame'], data['storyName']);
    } else {
        if (data['error'] === 'story-mode-paid') {
            notie.alert({type: 3, text: "This story is only available in JoW Paid"})
        } else if (data['error'] === 'pow-free-trial') {
            notie.alert({type: 3, text: "Passion of Wrestling is not available in the Free Trial"})
        } else if (data['error'] === 'sandbox-mode-paid') {
            notie.alert({type: 3, text: "Sandbox Mode is only available in JoW Paid"})
        } else if (data['error'] === 'local-multiplayer-mode-paid') {
            notie.alert({type: 3, text: "Local Multiplayer is only available in JoW Paid"})
        } else if (data['error'] === 'private-scenario') {
            notie.alert({type: 3, text: "This scenario has been set as private by the creator"})
        } else if (data['error'] === 'custom-starting-company-paid') {
            notie.alert({type: 3, text: "Custom Starting Company is only available in JoW Paid"})
        }
        else {
            notie.alert({type: 3, text: "There was an error creating the game. Please try again."})
        }
    }
}

function runScenariosSearch() {
    if (globals.requestRunning) {
        return false;
    }
    playSoundEffect('success');

    let searchTerm = $('.scenario-search-input').val();
    let filterPeriod = $('.scenario-search-options input[name="radio-scenario-search-period"]:checked').val();
    let filterStartingYear = $('.search-starting-year').val();
    let filterCompanyName = $('.search-company-name').val();

    makeGetRequest('/_search_scenarios', {query: searchTerm, companyName: filterCompanyName,
            startingYear: filterStartingYear, period: filterPeriod}, (data) => {
            // Show results
            let resultsContainer = $('#scenarios-search-results');
            resultsContainer.html('');
            data['scenarios'].forEach(function (scenario) {
                let scenarioHtml = getScenarioHtml(scenario);
                resultsContainer.append(scenarioHtml);
            });
            if (!data['scenarios'].length) {
                resultsContainer.append('<div class="scenario">No scenarios found.</div>')
            }
            resultsContainer.show();

            $('.scenario-search-input').focus();
            $('#our-scenarios').hide();
            $("#user-scenarios").hide();
            $("#tutorial-scenario").hide();
            $("#featured-scenario").hide();
            $('.scenario-sort').val('rating');

            $('#new-game-menu-container').scrollTop(0);
        }
    );
}

function processCustomCompanyOpenGraphicCreator(hide) {
    if (typeof (hide) === 'undefined') hide = true;
    let openCharacterCreator = $('.custom-starting-company-championships .character-creator:visible');
    if (openCharacterCreator.length > 0) {
        if (hide) {
            openCharacterCreator.find('.superstar-graphic').html('');
            openCharacterCreator.hide();
        }
        openCharacterCreator.find('.load-character-code-input').val('');
        // Save championship's graphics
        openCharacterCreator.find('.share-character').trigger('click');  // Trigger share and hide it
        openCharacterCreator.find('.share-character-code-container').hide();
        openCharacterCreator.find('.share-character').removeClass('selected');
        let characterData = openCharacterCreator.find('.share-character-code-input').val();
        if (characterData) {
            let selectedChampionship = $('.custom-starting-company-championship-add-graphic-button.blue-button-background').parent();
            selectedChampionship.data('key', characterData);
            if (hide) {
                selectedChampionship.find('.custom-starting-company-championship-add-graphic-button')
                    .addClass('dark-grey-button-background').removeClass('blue-button-background');
            }
        }
    }
}

async function showGenerateCustomStartingCompanyData({data} = {}) {
    // Add company attributes
    let parent = $('.custom-starting-company-container');
    parent.find('.custom-starting-company-name-input').val(data['companyName']);
    parent.find('.custom-starting-company-size-select').val(data['companySize']).trigger('change');
    parent.find('.custom-starting-company-finances-select').val(data['companyFinances']).trigger('change');
    parent.find('.custom-starting-company-weekly-show-name-input').val(data['weeklyShowName']);
    parent.find('.custom-starting-company-owner-name-input').val(data['ownerName']);
    parent.find('.custom-starting-company-style-select').val(data['companyStyle']);

    // Add events data
    parent.find('.custom-starting-company-event-name-input').each(function (i, e) {
        let eventData = data['companyEventsData'][i];
        $(e).val(eventData['name']);
        $(e).siblings('.custom-starting-company-event-prestige-select').val(eventData['prestige']);
    });

    // Remove extra championship inputs
    let championshipInputs = parent.find('.custom-starting-company-championship-name-input');
    championshipInputs.slice(1).parent().remove();

    // Reset graphic
    let championshipInputParent = championshipInputs.eq(0).parent();
    championshipInputParent.find('.custom-starting-company-championship-remove-graphic-button').hide();
    championshipInputParent.find('.custom-starting-company-championship-add-graphic-button').text('Add Graphic')
        .addClass('dark-grey-button-background').removeClass('blue-button-background');
    championshipInputParent.data('key', null);

    // Hide graphic creator
    parent.find('.character-creator').hide();
    parent.find('.character-creator').find('.superstar-graphic').html('');

    // Add championship inputs depending on number of company championships
    if (data['companyChampionshipsData'].length > 1) {
        let numberOfChampionshipInputsToAdd = data['companyChampionshipsData'].length - 1;
        let championshipInput = '<div class="margin-bottom-8">' + championshipInputs.eq(0).parent().clone().prop('innerHTML') +
            '<button type="button" class="remove-custom-starting-company-championship-input-button button retro-button styled-select-button ' +
            'font-bold top-1px margin-left-3"><i class="fa fa-minus"></i></button></div>';
        championshipInputs.eq(0).parent().after(championshipInput.repeat(numberOfChampionshipInputsToAdd));
    }

    // Add championships data
    parent.find('.custom-starting-company-championship-name-input').each(function (i, e) {
        let championshipData = data['companyChampionshipsData'][i];
        $(e).val(championshipData['name']);
        $(e).siblings('.custom-starting-company-championship-division-select').val(championshipData['division']);
        $(e).siblings('.custom-starting-company-championship-prestige-select').val(championshipData['prestige']);
    });
}

function getCompaniesListItemHtml(company, i, scenarioUid) {
    let html;
    if (i === 0) {
        html =
            '<div class="margin-top-8 company-list-item">' +
            '<span class="grey margin-bottom-2 display-block company-list-item-name">' + company + '</span>' +
            '<label class="control control--radio margin-right-10">User<input type="radio" name="radio-company-list-item-' +
            scenarioUid + '-' + company + '" ' +
            'checked="checked" value="user"/><div class="control__indicator"></div></label>' +
            '<label class="control control--radio margin-right-10">CPU<input type="radio" name="radio-company-list-item-' +
            scenarioUid + '-' + company + '" ' +
            'value="CPU"/><div class="control__indicator"></div></label>' +
            '<label class="control control--radio">None<input type="radio" name="radio-company-list-item-' +
            scenarioUid + '-' + company + '" ' +
            'value="none"/><div class="control__indicator"></div></label>' +
            '<input type="text" name="company-list-item-player-name" placeholder="Player Name" maxlength="15" class="styled-select player-name-input">' +
            '</div>';
    }
    else if (i < gameLimits.maxCompetitors) {
        html =
            '<div class="margin-top-8 company-list-item">' +
            '<span class="grey margin-bottom-2 display-block company-list-item-name">' + company + '</span>' +
            '<label class="control control--radio margin-right-10">User<input type="radio" name="radio-company-list-item-' +
            scenarioUid + '-' + company + '" ' +
            'value="user"/><div class="control__indicator"></div></label>' +
            '<label class="control control--radio margin-right-10">CPU<input type="radio" name="radio-company-list-item-' +
            scenarioUid + '-' + company + '" ' +
            'checked="checked" value="CPU"/><div class="control__indicator"></div></label>' +
            '<label class="control control--radio">None<input type="radio" name="radio-company-list-item-' +
            scenarioUid + '-' + company + '" ' +
            'value="none"/><div class="control__indicator"></div></label>' +
            '<input type="text" name="company-list-item-player-name" placeholder="Player Name" maxlength="15" class="styled-select player-name-input display-none">' +
            '</div>';
    }
    else {
        html =
            '<div class="margin-top-8 company-list-item">' +
            '<span class="grey margin-bottom-2 display-block company-list-item-name">' + company + '</span>' +
            '<label class="control control--radio margin-right-10">User<input type="radio" name="radio-company-list-item-' +
            scenarioUid + '-' + company + '" ' +
            'value="user"/><div class="control__indicator"></div></label>' +
            '<label class="control control--radio margin-right-10">CPU<input type="radio" name="radio-company-list-item-' +
            scenarioUid + '-' + company + '" ' +
            'value="CPU"/><div class="control__indicator"></div></label>' +
            '<label class="control control--radio">None<input type="radio" name="radio-company-list-item-' +
            scenarioUid + '-' + company + '" ' +
            'checked="checked" value="none"/><div class="control__indicator"></div></label>' +
            '<input type="text" name="company-list-item-player-name" placeholder="Player Name" maxlength="15" class="styled-select player-name-input display-none">' +
            '</div>';
    }
    return html;
}

function getScenarioEdits(uid, editsContainer, sort, page) {
    if (globals.requestRunning) {
        return false;
    }
    playSoundEffect('success');
    makeGetRequest('/_get_scenario_edits', {uid: uid, page: page, sort: sort}, (data) => {
        let editsHtml = '';
        if (data['edits'].length > 0) {
            data['edits'].forEach(function (edit, i) {
                let ratingHtmlEdit;
                if (edit['rating'] === null) {
                    ratingHtmlEdit = '<span class="rating no-rating">?? %</span>'
                } else {
                    if (edit['rating'] >= 50) {
                        ratingHtmlEdit = '<span class="rating positive">' + edit['rating'] + '%</span>'
                    } else {
                        ratingHtmlEdit = '<span class="rating negative">' + edit['rating'] + '%</span>'
                    }
                }

                // Check for existing rating, change rating icon
                let ratingIconsEdit;
                if (edit['rated_up']) {
                    ratingIconsEdit = '<i class="fa fa-thumbs-o-up icon-button margin-left-8 grey rate-up font-bold positive"></i>' +
                        '<i class="fa fa-thumbs-o-down icon-button margin-left-8 grey rate-down"></i>'
                } else if (edit['rated_down']) {
                    ratingIconsEdit = '<i class="fa fa-thumbs-o-up icon-button margin-left-8 grey rate-up"></i>' +
                        '<i class="fa fa-thumbs-o-down icon-button margin-left-8 grey rate-down font-bold negative"></i>'
                } else {
                    ratingIconsEdit = '<i class="fa fa-thumbs-o-up icon-button margin-left-8 grey rate-up"></i>' +
                        '<i class="fa fa-thumbs-o-down icon-button margin-left-8 grey rate-down"></i>';
                }

                // Edit options
                let showInfoIcon = '<i class="fa fa-question margin-left-3 font-1p125em ' +
                    'show-scenario-edit-info icon-button light"></i>';
                let deleteIcon = '';
                let editIcon = '';
                if (edit['show_delete']) {
                    deleteIcon = '<i class="fa fa-times-circle-o margin-left-3 font-1p125em ' +
                        'delete-scenario-edit icon-button light help-text" title="Delete"></i>';
                    editIcon = '<i class="fa fa-pencil-square-o margin-left-2 font-1p125em ' +
                        'edit-scenario-edit icon-button grey help-text" title="Edit"></i>';
                }

                let editPrivateHtml = '';
                let editNameClass = '';
                if (edit['private']) {
                    editPrivateHtml = '<span class="margin-left-5 light-grey">Private</span>';
                    editNameClass = ' brown-red';
                }

                let creatorHtml = '<span class="light-grey margin-right-3">by {0}</span>'.format(escapeHTML(edit['creator']));
                let datetimeUpdatedHtml = '<span class="high-light-grey margin-right-5 help-text" title="Date created/updated">{0}</span>'.format(edit['datetime_updated_string']);
                let editNameText = '{0}'.format(escapeHTML(edit['comments']));
                let editNameHtml = '<span class="margin-right-5' + editNameClass + '">' + editNameText + '</span>';
                let scenarioVersion = '<span class="high-light-grey help-text margin-right-3" title="Scenario version that the edit is based on">Scenario v{0}</span>'.format(edit['version']);
                let editVersion = '<span class="high-light-grey help-text" title="Edit version">Edit v{0}</span>'.format(edit['edit_version']);
                let editCompanyName = edit['company_name'];
                if (editCompanyName) {
                    editCompanyName = editCompanyName.replace(/"/g, "&quot;")
                }
                let confidenceRating = (edit['confidence_rating'] !== null) ? edit['confidence_rating'] : -1;
                let editText = '{0} {1} {2} {3} {4} {5}'.format(editNameHtml, ratingHtmlEdit, ratingIconsEdit,
                    showInfoIcon, editIcon, deleteIcon);
                let editInfo = '<span class="scenario-edit-info display-none margin-left-8">{0} {1} {2} {3} {4}</span>'.format(creatorHtml,
                    datetimeUpdatedHtml, scenarioVersion, editVersion, editPrivateHtml);
                editsHtml += '<div class="margin-bottom-10 scenario-edit" data-competition=\'' +
                    JSON.stringify(edit['competition']).replace(/'/g, "&#39;") + '\' data-uid="' + edit['uid'] +
                    '" data-date="' + edit['datetime_updated'] + '" data-confidence-rating="' + confidenceRating +
                    '" data-company-name="' + editCompanyName + '">' +
                    editText + editInfo +
                    '</div>';
            });
        }
        else {
            editsHtml += '<div class="light-grey margin-bottom-10">' +
                'No edits present' +
                '</div>';
        }

        let html = '<div class="purple display-inline-block">Edits</div> ' +
            '<div class="float-right top--2px">' +
            '<button type="button" class="button retro-button condensed light-button-background sort-scenario-edits-button ' +
            '" data-value="best">Best</button> ' +
            '<button type="button" class="button retro-button condensed light-button-background sort-scenario-edits-button' +
            '" data-value="new">New</button> ' +
            '<button type="button" class="button retro-button condensed light-button-background sort-scenario-edits-button' +
            '" data-value="my-edits">My Edits</button>' +
            '</div>' +
            '<div class="scroll-container margin-top-12">' + editsHtml + '</div>' +
            '<div class="column-left">' +
                '<button type="button" class="button retro-button condensed light-button-background scenario-edits-previous-page-button margin-top-10 no-margin-bottom">' +
                    'Prev' +
                '</button>' +
            '</div>' +
            '<div class="column-right text-right">' +
                '<button type="button" class="button retro-button condensed light-button-background scenario-edits-next-page-button margin-top-10 no-margin-bottom">' +
                    'Next' +
                '</button>' +
            '</div>' +
            '<div class="clear"></div>';

        editsContainer.html(html);
        editsContainer.show();
        editsContainer.find('.scroll-container').scrollTop(0);

        // Show/hide pagination buttons
        if (data['next_page']) {
            editsContainer.find('.scenario-edits-next-page-button').removeClass('visibility-hidden').data('page', data['next_page'])
        } else {
            editsContainer.find('.scenario-edits-next-page-button').addClass('visibility-hidden')
        }
        if (data['previous_page']) {
            editsContainer.find('.scenario-edits-previous-page-button').removeClass('visibility-hidden').data('page', data['previous_page'])
        } else {
            editsContainer.find('.scenario-edits-previous-page-button').addClass('visibility-hidden')
        }

        // Select sort button
        editsContainer.find('.sort-scenario-edits-button[data-value="' + sort + '"]').addClass('selected');
    });
}

function showScenarioInformation(scenarioData, el) {
    let companyInfo = scenarioData['companyInformation'];
    let championships = scenarioData['championships'];
    let gimmickMatches = scenarioData['gimmickMatches'];
    let rosters = scenarioData['rosters'];
    let brands = scenarioData['brands'];
    let competitors = scenarioData['competitorsData'];

    // Company info
    let companyInfoDiv = getCompanyInfo(companyInfo);

    // Championships
    let championshipsDiv = getChampionshipsInfo(championships);

    // Gimmick matches
    let topGimmickMatchesDiv = getItemListDiv(gimmickMatches['topGimmickMatches']);
    let gimmickMatchesDiv =
        '<div class="margin-bottom-25">' +
        '<div class="blue font-1p25em margin-bottom-12">Gimmick Matches</div>' +
        getItemColumnDiv('Top', topGimmickMatchesDiv) +
        '</div>';

    // Rosters
    let rostersDiv = '';
    rosters.forEach(function (roster, i) {
        let rosterDiv = getRosterInfo(roster);
        rostersDiv += rosterDiv;
        if (i === 0) {
            // Brands
            rostersDiv += getBrandsInfo(brands);
        }
    });

    // Competitors
    let competitorsDiv = '';
    competitors.forEach(function (competitor, i) {
        let competitorInfo = getCompanyInfo(competitor, true);
        let championshipsInfo = getChampionshipsInfo(competitor['championships'], true);

        // Rosters
        let rostersInfo = '';
        competitor['rosters'].forEach(function (roster, i) {
            let rosterDiv = getRosterInfo(roster, true);
            rostersInfo += rosterDiv;
            if (i === 0) {
                // Brands
                rostersInfo += getBrandsInfo(competitor['brands'], true);
            }
        });

        let divClass = '';
        if (i !== 0) {
            divClass = 'scenario-information-separator'
        } else {
            divClass = 'margin-top-25'
        }
        let competitorDiv = '<div class="' + divClass + '">' +
            competitorInfo + rostersInfo + championshipsInfo +
            '</div>';
        competitorsDiv += competitorDiv;
    });
    if (competitors.length < 1) {
        competitorsDiv = '<div class="grey">No competitors added</div>'
    }
    competitorsDiv =
        '<div>' +
        '<div class="blue font-1p25em margin-bottom-12">Competitors</div>' +
        competitorsDiv +
        '</div>';

    let scenarioInfoDiv = '<div>' + companyInfoDiv + rostersDiv + championshipsDiv + gimmickMatchesDiv +
        competitorsDiv + '</div>';
    $(el).append(scenarioInfoDiv).fadeIn();
    $(el).scrollTop(0);
}

export {playScenarioHandler, newGameMenuButtonHandler}